<template>
  <!-- Hero -->
  <section class="py-5 bg-white border-bottom">
    <div class="container py-4">
      <div class="row align-items-center g-4">
        <div class="col-lg-7">
          <div class="d-flex align-items-center gap-3 mb-3">
            <img src="/assets/img/logo.png" class="logo-large" />
            <h1 class="display-5 fw-bold m-0">FinPlan</h1>
          </div>

          <p class="lead text-muted mb-4">
            Простое приложение для учёта доходов, расходов и финансовых планов.
            Помогает видеть реальную картину по деньгам и контролировать траты.
          </p>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <div class="google-wrapper">
              <GoogleAuthBtn @login="loginWithGoogle" />
            </div>

            <RouterLink to="/auth" class="btn btn-outline-primary">
              Войти по email
            </RouterLink>
          </div>
        </div>

        <div class="col-lg-5">
          <div class="card shadow-sm border-0">
            <div class="card-body p-4">
              <h2 class="h5 fw-semibold mb-3">
                Что умеет FinPlan
              </h2>

              <ul class="mb-0 ps-3">
                <li class="mb-2">Учёт доходов и расходов</li>
                <li class="mb-2">Категории и счета</li>
                <li class="mb-2">Планы расходов и контроль бюджета</li>
                <li class="mb-2">Сравнение план / факт</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Features -->
  <section class="py-5">
    <div class="container">
      <div class="row g-4">
        <div class="col-md-4">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body p-4">
              <h3 class="h5">Счета</h3>
              <p class="text-muted mb-0">
                Храни баланс и операции по разным счетам в одном месте.
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body p-4">
              <h3 class="h5">Транзакции</h3>
              <p class="text-muted mb-0">
                Записывай доходы и расходы, фильтруй по датам и категориям.
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body p-4">
              <h3 class="h5">Планы</h3>
              <p class="text-muted mb-0">
                Ставь цели по расходам и сравнивай их с фактическими тратами.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import GoogleAuthBtn from "@/features/personal/components/GoogleAuthBtn.vue";

function loginWithGoogle() {
  //window.location.href = '/oauth2/authorization/google'
}
</script>

<style scoped>
.logo-large {
  width: 48px;
  height: 48px;
}
.google-btn {
  width: auto !important;
}
</style>